// scroll-to-top.component.ts
import { Component, OnInit, OnDestroy } from "@angular/core";
import { CommonModule, NgIf } from "@angular/common";

@Component({
  selector: "app-scroll-to-top",
  standalone: true,
  imports: [CommonModule, NgIf],
  templateUrl: "./scroll-to-top.component.html",
  styleUrls: ["./scroll-to-top.component.css"],
})
export class ScrollToTopComponent implements OnInit, OnDestroy {
  isVisible = false;
  private scrollContainer: HTMLElement | null = null;
  private boundOnScroll = this.onScroll.bind(this);

  ngOnInit(): void {
    // cible le conteneur scrollable (id présent dans ton markup)
    this.scrollContainer = document.getElementById("main-content");

    if (this.scrollContainer) {
      this.scrollContainer.addEventListener("scroll", this.boundOnScroll, {
        passive: true,
      });
      // état initial
      this.onScroll();
    } else {
      window.addEventListener("scroll", this.boundOnScroll, { passive: true });
      this.onScroll();
    }
  }

  ngOnDestroy(): void {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener("scroll", this.boundOnScroll);
    } else {
      window.removeEventListener("scroll", this.boundOnScroll);
    }
  }

  private onScroll(): void {
    const scrollTop = this.scrollContainer
      ? this.scrollContainer.scrollTop
      : window.scrollY;
    this.isVisible = scrollTop > 300; // ajustable
  }

  scrollToTop(): void {
    if (this.scrollContainer) {
      this.scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
}
